(() => {
  const key = 'atr:meta-custom-lead';
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; } };
  document.querySelectorAll('#atr-custom-enquiry, #enquiry-form').forEach(form => form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    try { sessionStorage.setItem(key, JSON.stringify({id: crypto.randomUUID(), at: Date.now(), path: location.pathname})); } catch {}
  }));
  const pending = read();
  if (!pending || pending.path !== location.pathname || Date.now() - pending.at > 1800000 ||
      !document.querySelector('#atr-custom-enquiry .atrx-success, #enquiry-form [data-atr-enquiry-success]')) return;
  let sent = false;
  const send = () => {
    if (sent || typeof window.fbq !== 'function' || !window.Shopify?.customerPrivacy?.marketingAllowed()) return;
    window.fbq('track', 'Lead', {content_name: 'Custom order enquiry', content_category: 'Custom orders'}, {eventID: pending.id});
    sent = true;
    try { sessionStorage.removeItem(key); } catch {}
  };
  document.addEventListener('visitorConsentCollected', send);
  let attempts = 0;
  const timer = setInterval(() => { send(); if (sent || ++attempts >= 30) clearInterval(timer); }, 1000);
  send();
})();